import { oauthConfig } from "../OauthConfig"
import { AuthAxios } from "./AuthAxios"
import { MembersStatsResponse, MemberDimension, MemberMetric, RetentionResponse } from "../responses"
import { DateTime } from "luxon"
import { TimeAggregation } from "@/types/customCharts"

interface FetchMembersStatsQuery {
    center: number
    from: string
    to: string
    interval: TimeAggregation
    multiplier: number
    dimensions: string
    metrics: string
    prevFrom?: string | null
    prevTo?: string | null
}

export const MembersApi = {
    fetchMembersStats: async (
        start: DateTime,
        end: DateTime,
        interval: TimeAggregation,
        centerId: number,
        dimensions: MemberDimension[],
        metrics: MemberMetric[],
        prevStart?: DateTime,
        prevEnd?: DateTime
    ): Promise<MembersStatsResponse> => {
        if (!interval) { interval = "month" }

        const params: FetchMembersStatsQuery = {
            center: centerId,
            from: start.toRFC2822()!,
            to: end.toRFC2822()!,
            interval,
            multiplier: 1,
            dimensions: dimensions.join(','),
            metrics: metrics.join(','),
        }

        if (prevStart) {
            params.prevFrom = prevStart.toRFC2822()
            params.prevTo = prevEnd?.toRFC2822()
        }

        return await AuthAxios.get(`${oauthConfig.authority}/api/v1/stats/members`, { params })
            .then(resp => resp.data)
    },

    fetchRetention: async (
        centerId: number,
        from: DateTime,
        to: DateTime
    ): Promise<RetentionResponse> => {
        return await AuthAxios.get(`${oauthConfig.authority}/api/v1/stats/members/retention`, {
            params: {
                center: centerId,
                from: from.toRFC2822()!,
                to: to.toRFC2822()!,
                interval: 'month',
            },
        }).then(resp => resp.data)
    },
}
